<template>
  <q-page padding>
    <div class="row col-12 justify-between">
      <div>
        <p class="text-h6 text-weight-bold text-brand-1 texto-titulo">
          Necessidades Solicitante em Aberto
        </p>
      </div>
    </div>

    <div class="q-ml-md">
      <section
        style="margin-bottom: -20px"
        class="row col-12 q-mt-md q-gutter-sm text-brand-1 text-weight-bold"
      >
        <div class="col-md col-xs">
          <div>Selecione o status:</div>
          <q-select
            :options="urgencia"
            label="Selecione um Status"
            dense
            outlined
            v-model="urgenciaValue"
          />
        </div>

        <div class="col-md col-2">
          <div>Com Comprador</div>
          <q-select
            :options="filtrosComprador"
            label="Comprador"
            dense
            outlined
            v-model="comprador"
            :rules="[(val) => val || 'Campo Obrigatório']"
          />
        </div>

        <div class="col-md col-2">
          <div>Responsável:</div>

          <SelectSolicitante
            :cutLength="20"
            label="Nome do Responsavel"
            v-model="responsavel"
          />
        </div>

        <div class="col-md col-2">
          <div>Criador Necessidade:</div>
          <q-input 
            outlined 
            dense 
            v-model="criadorNecessidade" 
            readonly
            bg-color="grey-3"
          />
        </div>

        <div class="col-md col-2">
          <div>Solicitante Necessidade:</div>
          <SelectSolicitante
            :cutLength="20"
            label="Nome do Solicitante"
            v-model="solicitanteNecessidade"
          />
        </div>
      </section>
      <section class="row col-12 q-gutter-sm text-brand-1 text-weight-bold">
        <div class="col-md col-2">
          <div class="q-ml-sm">Produto:</div>
          <q-input outlined dense v-model="produto"> </q-input>
        </div>

        <div class="col-md col-2">
          <div class="q-ml-sm">Numero Necessidade:</div>
          <q-input outlined dense v-model="numeroNecessidade"> </q-input>
        </div>

        <div class="col-md col-2">
          <div class="texto-titulo-input">Data Inicial</div>

          <q-input
            v-model="dataInicial"
            dense
            outlined
            class="texto-titulo-input"
            placeholder="DD/MM/AAAA"
            mask="##/##/####"
            :rules="[
              (val) =>
                val == '' || val.length == 10 || 'Digite a Data Completa',
            ]"
          >
            <template v-slot:append>
              <q-icon name="event" class="cursor-pointer">
                <q-popup-proxy
                  cover
                  transition-show="scale"
                  transition-hide="scale"
                >
                  <q-date
                    v-model="dataInicial"
                    :locale="myLocale"
                    mask="DD/MM/YYYY"
                    :rules="[
                      (val) =>
                        val == '' ||
                        val.length == 10 ||
                        'Digite a Data Completa',
                    ]"
                  >
                    <div class="row items-center justify-end">
                      <q-btn
                        v-close-popup
                        label="Fechar"
                        color="primary"
                        flat
                      />
                    </div>
                  </q-date>
                </q-popup-proxy>
              </q-icon>
            </template>
          </q-input>
        </div>

        <div class="col-md col-2">
          <div class="texto-titulo-input">Data Final</div>
          <q-input
            v-model="dataFinal"
            dense
            outlined
            class="texto-titulo-input"
            placeholder="DD/MM/AAAA"
            mask="##/##/####"
            :rules="[
              (val) =>
                val == '' || val.length == 10 || 'Digite a Data Completa',
            ]"
          >
            <template v-slot:append>
              <q-icon name="event" class="cursor-pointer">
                <q-popup-proxy
                  cover
                  transition-show="scale"
                  transition-hide="scale"
                >
                  <q-date
                    v-model="dataFinal"
                    :locale="myLocale"
                    mask="DD/MM/YYYY"
                    :rules="[
                      (val) =>
                        val == '' ||
                        val.length == 10 ||
                        'Digite a Data Completa',
                    ]"
                  >
                    <div class="row items-center justify-end">
                      <q-btn
                        v-close-popup
                        label="Fechar"
                        color="primary"
                        flat
                      />
                    </div>
                  </q-date>
                </q-popup-proxy>
              </q-icon>
            </template>
          </q-input>
        </div>
        <div class="col-md q-mt-lg col-2">
          <q-btn
            color="secondary q-mt-sm"
            icon="filter_alt"
            no-caps
            label="Aplicar filtros"
            @click="() => getDados()"
          />
        </div>
      </section>
    </div>

    <div class="q-mt-lg">
      <div
        class="row col-12 q-ml-lg justify-between items-center q-mt-md q-mb-sm text-brand-1 text-weight-medium"
        style="font-size: 16px"
      >
        <span>Todos os Produtos em aberto </span>
        <q-btn
          @click="exportar"
          class="q-ml-sm"
          icon="file_upload"
          label="Exportar"
          style="border-radius: 8px; background-color: #304f78; color: white"
          no-caps
        />
      </div>

      <q-table
        flat
        table-header-style="background-color: #d9effc"
        :rows="rows"
        title-class="text-brand-5 text-weight-bold"
        color="primary"
        class="tabela-tamanho-fixo"
        dense
        :columns="columns"
        :loading="disable"
        :filter="filtrar"
        hide-pagination
        v-model:pagination="pagination"
        :rows-per-page-options="[0]"
      >
        <template v-slot:body-cell-necessidade="props">
          <q-td class="text-brand-5 text-weight-bold" :props="props">
            <span>{{ props?.row?.numero }}</span>
          </q-td>
        </template>

        <template v-slot:body-cell-purchase_order_id="props">
          <q-td class="text-brand-5 text-weight-bold" :props="props">
            <span v-if="props.row.purchase_order_id != null">{{
              props?.row?.purchase_order_id
            }}</span>

            <span v-else>NÃO</span>
          </q-td>
        </template>
        <template v-slot:body-cell-detalhe="props">
          <q-td :props="props">
            <q-btn
              @click="irParaDetalhes(props.row.uuid)"
              icon="sym_o_article"
              flat
              round
              color="blue"
            />
          </q-td>
        </template>
      </q-table>
      <div class="row justify-center q-mt-md">
        <q-pagination
          :disable="disable"
          v-model="pagination.page"
          color="brand-5"
          active-color="secondary"
          active-text-color="white"
          :max="pagesNumber"
          :max-pages="5"
          :boundary-numbers="false"
          :direction-links="true"
          size="sm"
        />
      </div>
    </div>
  </q-page>
</template>

<script>
// Funçao para formatar quantidade (minimo 2 casas decimais, maximo 4)
const formatQuantidade = (value) => {
  if (!value && value !== 0) return "0,00";
  const num = Number(value);
  if (isNaN(num)) return "0,00";
  
  let formatted = num.toFixed(4);

  const parts = formatted.split('.');
  if (parts.length === 2) {
    let decimals = parts[1];
    while (decimals.length > 2 && decimals[decimals.length - 1] === '0') {
      decimals = decimals.slice(0, -1);
    }
    formatted = parts[0] + '.' + decimals;
  }
  
  return formatted.replace('.', ',');
};

const columns = [
  {
    name: "necessidade",
    label: "Necessidade #	",
    field: "necessidade",
    align: "left",
    style: "color: #707070; font-weight: bold",
  },
  {
    name: "criada",
    label: "Criada em	",
    field: (row) =>
      row?.created_at?.split(" ")[0].split("-").reverse().join("/"),
    align: "left",
    style: "color: #707070; font-weight: bold",
  },
  {
    name: "solicitante",
    label: "Solicitante",
    field: (row) => row?.solicitante_nome,
    align: "left",
    style: "color: #707070; font-weight: bold",
  },
  {
    name: "unit. controle",
    label: "Unidade de Controle",
    field: (row) => row?.cost_center_code,
    align: "left",
    style: "color: #707070; font-weight: bold",
  },
  {
    name: "responsavel",
    label: "Responsável",
    field: (row) => row?.responsavel_nome,
    align: "left",
    style: "color: #707070; font-weight: bold",
  },
  {
    name: "produto",
    label: "Produto",
    field: (row) => row?.produto_nome,
    align: "left",
    style: "color: #707070; font-weight: bold",
  },
  {
    name: "codigo",
    label: "Codigo",
    field: (row) => row?.product_codigo,
    align: "left",
    style: "color: #707070; font-weight: bold",
  },
  {
    name: "quantidae",
    label: "Qtd. de Compra",
    field: (row) => formatQuantidade(row?.quantidade_necessaria),
    align: "left",
    style: "color: #707070; font-weight: bold",
  },
  {
    name: "numero",
    label: "Unid. Medida",
    field: (row) => row?.unidade_medida,
    align: "left",
    style: "color: #707070; font-weight: bold",
  },
  {
    name: "purchase_order_id",
    label: "Ped. Compra",
    field: "purchase_order_id",
    align: "left",
    style: "color: #707070; font-weight: bold",
  },
  {
    name: "pedido",
    label: "Status Pedido",
    field: (row) => row?.status_pedido,
    align: "left",
    style: "color: #707070; font-weight: bold",
  },
  {
    name: "detalhe",
    label: "Detalhe",
    field: "detalhe",
    align: "left",
  },
];

import { ref, onMounted, watch, computed } from "vue";
import { useStore } from "vuex";
import { useQuasar } from "quasar";
import { useRouter } from "vue-router";
import SelectSolicitante from "../components/SelectSolicitante.vue";

export default {
  components: { SelectSolicitante },
  setup() {
    const store = useStore();
    const $q = useQuasar();
    const rows = ref([]);
    const disable = ref(true);
    const filtrar = ref("");
    const produto = ref("");
    const responsavel = ref("");
    const comprador = ref("");
    const numeroNecessidade = ref("");
    const criadorNecessidade = ref("");
    const solicitanteNecessidade = ref("");
    const formatDateBR = (date) => {
      const dia = String(date.getDate()).padStart(2, "0");
      const mes = String(date.getMonth() + 1).padStart(2, "0");
      const ano = date.getFullYear();
      return `${dia}/${mes}/${ano}`;
    };

    const hoje = new Date();
    const quinzeDiasAtras = new Date();
    quinzeDiasAtras.setDate(hoje.getDate() - 15);
    const dataInicial = ref(formatDateBR(quinzeDiasAtras));
    const dataFinal = ref(formatDateBR(hoje));
    const router = useRouter();
    let unidade = ref({
      nome: store.state.org.unidadeData,
      id: store.state.org.unidadeData.id,
    });
    const urgenciaValue = ref("");
    const pesquisarCentro = ref("");
    const pesquisarProduto = ref("");
    const listaProdutos = ref([]);

    const pagination = ref({
      sortBy: "desc",
      descending: false,
      page: 1,
      rowsPerPage: 15,
      rowsNumber: 15,
    });

    const getDados = async (page = 1, rowsPerPage = 10) => {
      disable.value = true;
      try {
        const response = await store.dispatch("compras/produtosAbertos2", {
          page: page,
          per_page: rowsPerPage,
          associado: undefined,
          comprado: urgenciaValue.value.value,
          criador: criadorNecessidade.value || store.state.autenticacao.usuarioLogado.email,
          user: solicitanteNecessidade.value?.sap,
          produto: produto.value == "" ? undefined : produto.value,
          responsavel: responsavel.value?.sap,
          com_comprador: comprador?.value?.value,
          numero:
            numeroNecessidade.value == "" ? undefined : numeroNecessidade.value,
          data_inicial:
            dataInicial.value == ""
              ? undefined
              : dataInicial.value.split("/").reverse().join("-"),
          data_final:
            dataFinal.value == ""
              ? undefined
              : dataFinal.value.split("/").reverse().join("-"),
        });

        rows.value = response.data.data;

        pagination.value.rowsPerPage = response.data.per_page;
        pagination.value.rowsNumber = response.data.total;
        pagination.value.page = response.data.current_page;

        disable.value = false;
      } catch (error) {
        $q.notify({
          message: "Erro a o encontrar dados",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };

    const handleRequest = async () => {
      getDados(pagination.value.page, pagination.value.rowsPerPage);
    };

    const exportar = async () => {
      try {
        await store.dispatch("compras/produtosAbertos2", {
          associado: undefined,
          comprado: urgenciaValue.value.value,
          data_inicial: "01/01/2021",
          user: store.state.autenticacao.usuarioLogado.email,
          download: "excel",
        });

        $q.notify({
          message: "Exportado com Sucesso",
          color: "positive",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      } catch (error) {
        $q.notify({
          message: "Erro a o exportar",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };

    const listaCentroCustos = ref([]);

    const irParaDetalhes = (uuidNecessidade) => {
      router.push({
        name: "compras-detalhe-necessidade-manual",
        params: { id: uuidNecessidade },
      });
    };

    const rota = async (rota, param = "") => {
      if (param != "") {
        router.push({
          name: rota,
          params: { id: param },
        });
      } else {
        router.push({
          name: rota,
        });
      }
    };

    watch(
      () => pagination.value.page,
      () => {
        disable.value = true;
        handleRequest();
      }
    );

    watch(
      () => store.state.org.unidadeData,
      () => {
        getDados();
      }
    );

    onMounted(() => {
      criadorNecessidade.value = store.state.autenticacao.usuarioLogado.email;
      getDados();
    });

    return {
      pagination,
      rows,
      disable,
      columns,
      filtrar,
      getDados,
      urgenciaValue,
      exportar,
      produto,
      numeroNecessidade,
      listaCentroCustos,
      pesquisarCentro,
      pesquisarProduto,
      handleRequest,
      rota,
      listaProdutos,
      comprador,
      responsavel,
      criadorNecessidade,
      solicitanteNecessidade,
      irParaDetalhes,
      formatQuantidade,

      pagesNumber: computed(() =>
        Math.ceil(pagination.value.rowsNumber / pagination.value.rowsPerPage)
      ),
      filtrosComprados: [
        {
          label: "Comprados",
          value: 1,
        },
        {
          label: "Não Comprados",
          value: 0,
        },
        {
          label: "Todos",
          value: 2,
        },
      ],

      myLocale: {
        days: "Domingo_Segunda_Terça_Quarta_Quinta_Sexta_Sábado".split("_"),
        daysShort: "Dom_Seg_Ter_Quar_Quin_Sex_Sáb".split("_"),
        months:
          "Janeiro_Fevereiro_Março_Abril_Maio_Junho_Julho_Agosto_Setembro_Outubro_Novembro_Dezembro".split(
            "_"
          ),
        monthsShort: "Jan_Fev_Mar_Abr_Mai_Jun_Jul_Ago_Set_Out_Nov_Dez".split(
          "_"
        ),
        firstDayOfWeek: 1,
      },
      unidade,
      urgencia: [
        { label: "COMPRADOS", value: 1 },
        { label: "NÃO COMPRADOS", value: 0 },
        { label: "TODOS", value: 2 },
      ],
      filtrosComprador: [
        {
          label: "Comprador Definido",
          value: 1,
        },
        {
          label: "Comprador não Definido",
          value: 0,
        },
        {
          label: "Todos",
          value: undefined,
        },
      ],
      dataInicial,
      dataFinal,
    };
  },
};
</script>

<style scoped>
.align {
  align-items: center;
}
theader tr th {
  white-space: pre-wrap !important;
}
tbody tr td {
  white-space: pre-wrap !important;
}

a {
  text-decoration: none;
}
.align {
  align-items: center;
}
.input-lote-qtd {
  width: 80px;
  margin-left: 5px;
  font-size: 11px;
}

.cursor {
  cursor: pointer;
}
.container-link-voltar {
  margin-right: 10px;
}
.icon-voltar {
  font-size: 25px;
}
.texto-titulo {
  font-size: 20px;
}
@media (max-width: 600px) {
  .texto-titulo {
    font-size: 16px;
  }
  .container-link-voltar {
    margin: 5px 0px 0px 0px;
  }
  .icon-voltar {
    font-size: 20px;
    margin-right: 1px;
  }
}
</style>
